import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M8 9h8v10H8z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 4l-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9z"
})), 'DeleteTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DeleteTwoTone.js
// module id = 3087
// module chunks = 2